import { render, staticRenderFns } from "./bank-account-info.vue?vue&type=template&id=97158edc&scoped=true&"
import script from "./bank-account-info.vue?vue&type=script&lang=js&"
export * from "./bank-account-info.vue?vue&type=script&lang=js&"
import style0 from "./bank-account-info.vue?vue&type=style&index=0&id=97158edc&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97158edc",
  null
  
)

export default component.exports